// Soft two-tone chime (880 Hz then 660 Hz) played each time the doctor arrival
// reminder fires. Audio must never break the UI, so every call is guarded.

let sharedContext = null;

const getContext = () => {
  if (typeof window === "undefined") return null;
  const AudioContextClass = window.AudioContext || window.webkitAudioContext;
  if (!AudioContextClass) return null;
  if (!sharedContext || sharedContext.state === "closed") {
    sharedContext = new AudioContextClass();
  }
  return sharedContext;
};

// Browsers start an AudioContext "suspended" until the page has had a user
// gesture. Calling this from a click/keydown lets later chimes play.
export const unlockChime = () => {
  try {
    const context = getContext();
    if (context && context.state === "suspended" && context.resume) {
      const resumed = context.resume();
      if (resumed && resumed.catch) resumed.catch(() => {});
    }
  } catch (e) {
    // ignore
  }
};

export const playChime = () => {
  try {
    const context = getContext();
    if (!context) return;
    if (context.state === "suspended" && context.resume) {
      const resumed = context.resume();
      if (resumed && resumed.catch) resumed.catch(() => {});
    }
    [
      [880, 0],
      [660, 0.18],
    ].forEach(([frequency, delay]) => {
      const oscillator = context.createOscillator();
      const gain = context.createGain();
      const start = context.currentTime + delay;
      oscillator.type = "sine";
      oscillator.frequency.value = frequency;
      oscillator.connect(gain);
      gain.connect(context.destination);
      gain.gain.setValueAtTime(0, start);
      gain.gain.linearRampToValueAtTime(0.18, start + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.001, start + 0.5);
      oscillator.start(start);
      oscillator.stop(start + 0.55);
    });
  } catch (e) {
    // No audio device, autoplay blocked, etc.: the modal still shows.
  }
};
